import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EvrideoCommonModule } from "../common/evrideo-common.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";
import { RouterModule } from "@angular/router";
import { InlineSVGModule } from "ng-inline-svg-2";
import { FormsModule } from "@angular/forms";
import { AngularDraggableModule } from "angular2-draggable";
import { BroadcastEditorComponent } from "./broadcast-editor/broadcast-editor.component";
import { BroadcastsRoutes } from "./broadcasts.routes";
import { SwitcherItemComponent } from "./switcher-item/switcher-item.component";
import { IBroadcastsRepository } from "../../domain/broadcasts/i-broadcasts-repository";
import { CachedBroadcastsRepository } from "../../infrastructure/broadcasts/cached-broadcasts-repository";
import { SwitchItemBlockManagerComponent } from "./switcher-item/switch-item-block-manager/switch-item-block-manager.component";
import { BroadcastEditorAudioMixerComponent } from "./broadcast-editor/broadcast-editor-audio-mixer/broadcast-editor-audio-mixer.component";
import { TakeOverConfirmDialogComponent } from "./take-over-confirm-dialog/take-over-confirm-dialog.component";
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    EvrideoCommonModule,
    BrowserAnimationsModule,
    AngularDraggableModule,
    InlineSVGModule.forRoot(),
    ToastrModule.forRoot({
      positionClass: "toast-top-center",
      tapToDismiss: false,
      timeOut: 5000,
    }),
    RouterModule.forRoot(BroadcastsRoutes),
  ],
  declarations: [
    BroadcastEditorComponent,
    SwitcherItemComponent,
    SwitchItemBlockManagerComponent,
    BroadcastEditorAudioMixerComponent,
    TakeOverConfirmDialogComponent,
  ],
  providers: [
    {
      provide: IBroadcastsRepository,
      useClass: CachedBroadcastsRepository,
    },
  ],
  exports: [],
})
export class BroadcastsModule {}
